export default __webpack_public_path__ + "static/media/V6QVC6e.5091c63a.jpeg";